<avs-device-picker
  class="block mb-4"
  (selectedDevicesChange)="onDevicesChange($event)"
  [apiFilters]="{ dataPoint: 'connected' }"
  [assignedDevices]="assignedDevices()"
  scrollBlockHeight="250px"
  sessionFiltersId="connected-devices-widget-options"
/>
